import { Component, input, model, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbNavModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'adf-sidebar',
  standalone: true,
  imports: [CommonModule, NgbNavModule, NgbTooltip, TranslatePipe],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit {
  isOpen = model<boolean>(true);
  isEnabled = input<boolean | null>(true);

  ngOnInit(): void {}

  onToggle() {
    this.isOpen.update((value) => !value);
  }
}
